<template>
<div class="wrapper">
   <Dialog header="Karta" :visible.sync="displayModal" :style="{width: '50vw'}" :modal="true">
      <Map
        :dataArray = "mapArray"
        width="100%"
        zoom = ""
        :getGeoCoder = false
        height="500px" />
    <template #footer>
        <Button label="Stäng" icon="pi pi-check" @click="closeModal" />
    </template>
  </Dialog>
  <TabView>
    <TabPanel v-for="order in mergedOrders" :key="order.id" :header="getOrderHeader(order)" :active="order.id === mergedOrders[0].id">
      <FeralcoOrdersDetailsTab v-if="order.type == 'feralco'" :order="order" :mergedOrders="mergedOrders" />
      <FeralcoInternOrderDetails v-if="order.type == 'feralcoIntern'" :orderIdFromTab="order.id" />
    </TabPanel>
  </Tabview>
</div>
</template>

<script>

import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import FeralcoOrdersDetailsTab from '@/components/Orders/FeralcoOrdersDetailsTab'
import FeralcoInternOrderDetails from '@/components/Orders/FeralcoInternOrderDetails'
import Map from '@/components/Map/Map'
import Button from 'primevue/button'
import { bus } from '../../main'
import Dialog from 'primevue/dialog'

export default {
  name: 'OrderDetails',
  components: {
    FeralcoOrdersDetailsTab,
    FeralcoInternOrderDetails,
    TabView,
    TabPanel,
    Map,
    Dialog,
    Button
  },
  data () {
    return {
      mergedOrders: [],
      mapArray: [],
      displayModal: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.init()
    }
  },
  async mounted () {
    const responseData = await this.getOrder()
    const relatedOrders = await this.getRelatedOrders(responseData.order)
    this.mergedOrders = [responseData.order, ...relatedOrders]

    bus.$on('addedCustomerPlace', (customerPlace) => {
      this.mapArray.push({Name: customerPlace.name, Address: customerPlace.name, Postal: '', City: '', Latitude: parseFloat(customerPlace.latitude), Longitude: parseFloat(customerPlace.longitude), Title: customerPlace.name, Data: customerPlace.name})
    })
    bus.$on('removedCustomerPlace', (customerPlace) => {
      this.mapArray = this.mapArray.filter(function (obj) {
        return obj.Name !== customerPlace.name
      })
    })
    bus.$on('openMapModal', (e) => {
      this.openModal()
    })
  },
  methods: {
    async init () {
      const responseData = await this.getOrder()
      const relatedOrders = await this.getRelatedOrders(responseData.order)
      this.mergedOrders = [responseData.order, ...relatedOrders]
    },
    getOrderHeader (order) {
      if (order.type === 'feralco') {
        return order.data.SalesId + ' ' + order.data.DeliveryPlaceCity
      } else if (order.type === 'feralcoIntern') {
        return 'Internorder ' + order.id
      }
    },
    async getOrder () {
      let response = await this.$http.get('/api/orders/by-type/feralco/' + this.$route.params.id)
      return response.data
    },
    async getRelatedOrders (order) {
      let response = await this.$http.get('/api/orders/get-related/' + this.$route.params.id + '/' + order.data.GroupLoading)
      return response.data
    },
    setMapArray () {
      this.mapArray = []
      for (let order of this.mergedOrders) {
        if (order.data.CustomerPlaces !== undefined) {
          for (let customerPlace of order.data.CustomerPlaces) {
            this.mapArray.push({Name: customerPlace.name, Address: customerPlace.name, Postal: '', City: '', Latitude: parseFloat(customerPlace.latitude), Longitude: parseFloat(customerPlace.longitude), Title: customerPlace.name, Data: customerPlace.name})
          }
        }
      }
    },
    openModal () {
      this.displayModal = true
      setTimeout(() => this.setMapArray(), 1000)
    },
    closeModal () {
      this.displayModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/FeralcoOrdersDetails.vue